import {isUserLoggedIn, logoutCall} from "../service/AuthService";
import {
    Archive, ExternalLink, Files,
    MoreHorizontal, Settings, Upload
} from "lucide-react";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import logo from "../images/Logo.png";


const selected = 'white';
const selectedBorder = '1px solid black';
const collapsed = '0';
const expanded = '140px';
const lightgrey = 'lightgrey';
const black = 'black';
const noLinksList = ["login", "signup", "forgot-password", "terms", "privacy"];

function Header(props) {
    const [dropDownHeight, setDropDownHeight] = useState('0');
    const [loggedIn, setLoggedIn] = useState(() => isUserLoggedIn());
    const [middleBorderColor, setMiddleBorderColor] = useState('black');
    const [middleOpacity, setMiddleOpacity] = useState(1);
    const [transformTop, setTransformTop] = useState('none');
    const [transformBottom, setTransformBottom] = useState('none');
    const [slideMenuWidth, setSlideMenuWidth] = useState('0');
    const [slideLinkOpacity, setSlideLinkOpacity] = useState('0');
    const [hamburgerPosition, setHamburgerPosition] = useState('');
    const navigate = useNavigate();

    function handleHamburgerClick() {
        setMiddleBorderColor(middleBorderColor === lightgrey ? black : lightgrey);
        setMiddleOpacity(middleOpacity === 1 ? 0 : 1);
        setTransformTop(transformTop === 'none' ? 'rotate(45deg)' : 'none');
        setTransformBottom(transformBottom === 'none' ? 'rotate(-45deg)' : 'none');
        setSlideMenuWidth(slideMenuWidth === '0' ? 'calc(100% + 32px)' : '0');
        setSlideLinkOpacity(slideLinkOpacity === '0' ? '1' : '0');
        setHamburgerPosition(hamburgerPosition === '' ? 'fixed' : '');
    }

    function handleDropDown() {
        setDropDownHeight(dropDownHeight === collapsed ? expanded : collapsed);
    }

    function logout() {
        try {
            logoutCall(true).then(loginResponse => {
                if (loginResponse === 500) {
                    window.alert("Could not log out");
                } else {
                    setLoggedIn(isUserLoggedIn()); // Only update once logout completes
                    navigate("/");
                }
            })
                .catch(error => {
                    console.error("Error logging out:", error);
                    window.alert("Could not log out");
                });
        } catch (error) {
            console.error("Error logging out:", error);
            window.alert("Could not log out");
        }
    }


    return (
        <div className="header">
            <div className="logo-wrapper logo-desktop" onClick={() => navigate("/")}>
                <img src={logo} alt="logo" className={"logo"}/>
            </div>
            <div className={"header-items"}>
                {!noLinksList.includes(props.page) &&
                    <div className={"nav-links"}>
                        <a href={"/"} className={"nav-link nav-link-hidden"}
                           style={{
                               backgroundColor: props.page === 'upload' ? selected : 'none',
                               outline: props.page === 'upload' ? selectedBorder : 'none'
                           }}>Upload</a>
                        <a href={"/score-history"} className={"nav-link nav-link-hidden"}
                           style={{
                               backgroundColor: props.page === 'score-history' ? selected : 'none',
                               outline: props.page === 'score-history' ? selectedBorder : 'none'
                           }}>Score History</a>
                        <a href={"/submissions"} className={"nav-link nav-link-hidden"}
                           style={{
                               backgroundColor: props.page === 'submissions' ? selected : 'none',
                               outline: props.page === 'submissions' ? selectedBorder : 'none'
                           }}>Submissions</a>
                        {/*<a href={"/export-center"} className={"nav-link nav-link-hidden"}*/}
                        {/*   style={{backgroundColor: props.page === 'export-center' ? selected : 'none', border: props.page === 'export-center' ? selectedBorder : 'none'}}>Export Center</a>*/}
                        <a href={"/dashboard-settings"} className={"nav-link nav-link-hidden"}
                           style={{
                               backgroundColor: props.page === 'dashboard-settings' ? selected : 'none',
                               outline: props.page === 'dashboard-settings' ? selectedBorder : 'none'
                           }}>Dashboard Settings</a>
                        <a href={"/feedback"} className={"nav-link nav-link-hidden"}
                           style={{
                               backgroundColor: props.page === 'feedback' ? selected : 'none',
                               outline: props.page === 'feedback' ? selectedBorder : 'none'
                           }}>Feedback</a>
                    </div>
                }
                <div className={"user-icon-wrapper"}>
                    <MoreHorizontal size={36} className={"user-icon"} onClick={() => handleDropDown()}/>
                    <div className={"user-dropdown"} style={{height: dropDownHeight}}>
                        {loggedIn ?
                            <div>
                                <div className={"dropdown-entry hover-grey"}>
                                    <a href={"/account"} className={"dropdown-entry-link"}>Account</a>
                                </div>
                            </div>
                            :
                            <div>
                                <div className={"dropdown-entry hover-grey"}>
                                    <a href={"/login"} className={"dropdown-entry-link"}>Sign In</a>
                                </div>
                                <div className={"dropdown-entry hover-grey"}>
                                    <a href={"/signup"} className={"dropdown-entry-link"}>Sign Up</a>
                                </div>
                            </div>
                        }
                            <div className={"dropdown-entry hover-grey"}>
                                <a href={"/about"} className={"dropdown-entry-link"}>About</a>
                            </div>
                            <div className={"dropdown-entry hover-grey"}>
                                <a href={"/faq"} className={"dropdown-entry-link"}>FAQ</a>
                            </div>
                            <div className={"dropdown-entry hover-grey"}>
                        <a href="/terms.pdf" target="_blank" rel="noopener noreferrer"
                           className={"dropdown-entry-link"}>Terms</a>
                    </div>
                    <div className={"dropdown-entry hover-grey"}>
                        <a href="/privacy.pdf" target="_blank" rel="noopener noreferrer"
                           className={"dropdown-entry-link"}>Privacy</a>
                    </div>
                        {loggedIn &&
                            <div className={"dropdown-entry hover-grey"} onClick={() => logout()}>Log Out</div>
                        }
                </div>
            </div>
            {/*<div className={"signin-signup-buttons"}>*/}
            {/*    <a href={"/login"} className={"sign-in-button"}>Sign In</a>*/}
            {/*    <a href={"/signup"} className={"sign-up-button"}>Sign Up</a>*/}
            {/*</div>*/}
        </div>
    <div className={"header-small"}>
        <div className="logo-wrapper" onClick={() => navigate("/")}>
            <img src={logo} alt="logo" className={"logo"}/>
        </div>
        {!noLinksList.includes(props.page) &&
            <div>
                <div className={"nav-links-small"}>
                    <a href={"/"} className={"nav-link-small nav-link-hidden"}
                    ><Upload/></a>
                    <a href={"/score-history"} className={"nav-link-small nav-link-hidden"}
                    ><Archive/></a>
                    <a href={"/submissions"} className={"nav-link-small nav-link-hidden"}
                    ><Files/></a>
                    {/*<a href={"/export-center"} className={"nav-link-small nav-link-hidden"}*/}
                    {/*   ><ExternalLink/></a>*/}
                    <a href={"/dashboard-settings"} className={"nav-link-small nav-link-hidden"}
                    ><Settings/></a>
                </div>
                <div className={"small-header-descriptions"}>
                    <div className={"small-header-description small-header-description-first"}>Upload</div>
                    <div className={"small-header-description"}>History</div>
                    <div className={"small-header-description"}>Submissions</div>
                    <div className={"small-header-description"}>Settings</div>
                </div>
                {/*<div className={"na"}>*/}
                {/*    <div>History</div>*/}
                {/*<a href={"/score-history"} className={"nav-link-small nav-link-hidden"}*/}
                {/*><Archive/></a>*/}
                {/*<a href={"/submissions"} className={"nav-link-small nav-link-hidden"}*/}
                {/*><Files/></a>*/}
                {/*/!*<a href={"/export-center"} className={"nav-link-small nav-link-hidden"}*!/*/}
                {/*/!*   ><ExternalLink/></a>*!/*/}
                {/*<a href={"/dashboard-settings"} className={"nav-link-small nav-link-hidden"}*/}
                {/*><Settings/></a>*/}
                {/*</div>*/}
            </div>
        }

        <div className={"hamburger"} style={{position: hamburgerPosition}}
             onClick={() => handleHamburgerClick()}>
            <MoreHorizontal size={36} className={"user-icon"} onClick={() => handleDropDown()}/>

        </div>
        <div className={"slide-menu"} style={{width: slideMenuWidth}}>
            <div className={"slide-links"} style={{opacity: slideLinkOpacity}}>
                <div className={"slide-link"}>
                    {!loggedIn ?
                        <a href={"/login"} className={"slide-link-a"}>Sign In</a>
                        :
                        <a href={"/account"} className={"slide-link-a"}>Account</a>
                    }
                </div>
                {!loggedIn &&
                    <div className={"slide-link"}>
                        <a href={"/signup"} className={"slide-link-a"}>Sign Up</a>
                    </div>
                }
                {!noLinksList.includes(props.page) &&
                    <div className={"slide-link"}>
                        <a href={"/feedback"} className={"slide-link-a"}>Feedback</a>
                    </div>
                }
                <div className={"slide-link"}>
                    <a href={"/about"} className={"slide-link-a"}>About</a>
                </div>
                <div className={"slide-link"}>
                    <a href={"/faq"} className={"slide-link-a"}>FAQ</a>
                </div>
                <div className={"slide-link"}>
                    <a href="/terms.pdf" target="_blank" rel="noopener noreferrer" className={"slide-link-a"}>Terms &
                        Conditions</a>
                </div>
                <div className={"slide-link"}>
                    <a href="/privacy.pdf" target="_blank" rel="noopener noreferrer" className={"slide-link-a"}>Privacy
                        Policy</a>
                </div>
                {loggedIn &&
                    <div className={"slide-link"}>
                        <div className={"slide-link-a"} onClick={() => logout()}>Log Out</div>
                    </div>
                }
            </div>
        </div>
    </div>
{/*<div className={"header-small"}>*/
}
{/*    <div className="logo-wrapper" onClick={() => navigate("/")}>*/
}
{/*        <img src={logo} alt="logo" className={"logo"}/>*/
}
{/*    </div>*/
}
{/*    <div className={"hamburger"} style={{position: hamburgerPosition}}*/
}
{/*         onClick={() => handleHamburgerClick()}>*/
}
{/*        <div className={"hamburger-line"} style={{transform: transformTop}}></div>*/
}
{/*        <div className={"hamburger-line"}*/
}
{/*             style={{borderColor: middleBorderColor, opacity: middleOpacity}}></div>*/
}
{/*        <div className={"hamburger-line"} style={{transform: transformBottom}}></div>*/
}
{/*    </div>*/
}
{/*    <div className={"slide-menu"} style={{width: slideMenuWidth}}>*/
}
{/*        <div className={"slide-links"} style={{opacity: slideLinkOpacity}}>*/
}
{/*            <div className={"slide-link"}>*/
}
{/*                {!loggedIn ?*/
}
{/*                    <a href={"/login"} className={"slide-link-a"}>Sign In</a>*/
}
{/*                    :*/
}
{/*                    <a href={"/account"} className={"slide-link-a"}>Account</a>*/
}
{/*                }*/
}
{/*            </div>*/
}
{/*            <div className={"slide-link"}>*/
}
{/*                {!loggedIn ?*/
}
{/*                    <a href={"/signup"} className={"slide-link-a"}>Sign Up</a>*/
}
{/*                    :*/
}
{/*                    <div className={"slide-link-a"} onClick={() => logout()}>Log Out</div>*/
}
{/*                }*/
}
{/*            </div>*/
}

{/*        </div>*/
}
{/*    </div>*/
}
{/*    /!*<div className={"tex-med-title"} onClick={() => navigate("/")}>TexMed Cannabis</div>*!/*/
}
{/*</div>*/
}
</div>
)
}

export default Header;